import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ComponentFactoryResolver,
  ViewChild
} from '@angular/core';
import {ConfirmationService, MenuItem, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {ReportProfile} from '../../../model/archive/report-profile';
import {base64StringToBlob} from 'blob-util';
import {FormFieldConfig} from '../../../model/api/form-field-config';
import {FieldRecord} from '../../../model/api/field-record';
import {FieldRequest} from '../../../model/api/field-request';
import {ReportTemplate} from '../../../model/archive/report-template';
import {ProfileAbsService} from '../../../services/archive/profile-abs.service';
import {CcBaseComponent} from "../../../crystal-elements/cc-base.component";
import {FormFieldGroupConfig} from "../../../model/api/form-field-group-config";
import {TableColumnConfig} from "../../../model/api/table-column-config";
import {ApiFileResponse} from "../../../model/api/api-file-response";
import {TradeTableComponent} from "../../clearing/table/trade/trade-table.component";
import {FileUtils} from "../../../utils/file-utils";
import {ReportTask} from "../../../model/archive/report-task";
import {ReportTaskService} from "../../../services/archive/report-task.service";
import {CookieNames} from "../../../shared/cookie/cookie-names";
import {DatePipe, DecimalPipe} from "@angular/common";
import {CcFormComponent} from "../../../crystal-elements/form-dialog/form/cc-form.component";
import * as XLSX from 'xlsx';
import {TabView} from "primeng/tabview";
import {ReportFormTab} from "../../../model/archive/report-form-tab";
import {ExchangeDetail} from "../../../model/exchange/exchange-detail";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {NotificationService} from "../../../services/security/notification.service";
import {Notification} from "../../../model/security/notification";
import {UserInfoStorageService} from "../../../services/auth/user-info-storage.service";
import {AppConfigService} from "../../../services/app-config.service";
import {CcStorageService} from "../../../services/common/cc-storage.service";
import TYPE = FormFieldConfig.TYPE;
import EXPORT_DATE_MODE = ReportProfile.EXPORT_DATE_MODE;
import EXPORT_FORMAT = ReportProfile.EXPORT_FORMAT;
import {EMPTY, exhaustMap, switchMap, take, takeUntil, timer} from "rxjs";
import {catchError, filter, map, tap} from "rxjs/operators";

type AOA = any[][];

@Component({
  template: '',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
    DatePipe,
    DecimalPipe
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArchiveFormAbsComponent extends CcBaseComponent {

  exportTemplates: FieldRecord<ReportTemplate>[] = [];
  exportProfiles: FieldRecord<ReportProfile>[] = [];
  exportFormats: FieldRecord<any>[] = [];
  profileAbsService: ProfileAbsService;

  exchanges: FieldRecord<ExchangeDetail>[] = []


  transPartKey: string;
  formLoading: boolean;
  formConfig: FormFieldGroupConfig[] = [];
  formRecord: any = {};
  currentGeneratedProfile: ReportProfile;
  settingsFormLoadingProgressValue: number = 0;
  globalErrorMessage: string;
  formSubmitted: boolean;
  selectedTemplate: ReportTemplate = undefined;
  selectedProfile: ReportProfile = undefined;

  tableLoading: boolean;

  reportFormTabs: ReportFormTab[] = [];

  currentApiFileResponse: ApiFileResponse;

  inProgressTaskCount: number = 0

  @ViewChild('tableResult')
  tableResult: TradeTableComponent;

  @ViewChild('ccForm')
  ccForm: CcFormComponent;

  @ViewChild('ccTabView')
  ccTabView: TabView;

  items: MenuItem[] = [];

  forceDayValue: boolean = true;
  useProfiles: boolean = false;

  public tableHeight: string = "60vh";

  public origin: String;

  constructor(cdref: ChangeDetectorRef,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              protected confirmationService: ConfirmationService,
              profileAbsService: ProfileAbsService,
              translateService: TranslateService,
              protected reportTaskService: ReportTaskService,
              private notificationService: NotificationService,
              protected commonFieldService: CommonFieldService,
              protected appConfigService: AppConfigService,
              private storageService: CcStorageService,
              private userInfoStorageService: UserInfoStorageService) {
    super(cdref, messageService, translateService);

    this.profileAbsService = profileAbsService;
  }

  ngOnInit() {
    if (this.storageService.check(this.origin + CookieNames.ARCHIVE_FORM_FORCEDAY)) {
      this.forceDayValue = this.storageService.get(this.origin + CookieNames.ARCHIVE_FORM_FORCEDAY) === 'true';
    }
    if (this.storageService.check(this.origin + CookieNames.ARCHIVE_FORM_USEPROFILES)) {
      this.useProfiles = this.storageService.get(this.origin + CookieNames.ARCHIVE_FORM_USEPROFILES) === 'true';
    }
    super.ngOnInit();
  }

  ngAfterContentInit() {
    this.reloadForm();
    // setTimeout(() => {
    //   // this.refreshFormConfig(false);
    //   // if (this.ccForm)
    //   //   this.ccForm.reloadFieldValueMap();
    // this.detectChanges();
    // });
  }

  protected initConfigs() {
    super.initConfigs();
    // this.refreshFormConfig(true);
  }

  public refreshFormConfig(clearRecord: boolean) {
    this.formConfig = [
      {
        fields:
          [{
            field: 'exportTemplate',
            'required': true,
            column: 3,
            type: TYPE.DROPDOWN,
            filter: true,
            options: () => this.exportTemplates,
            changed: event => {
              this.selectedTemplate = this.exportTemplates.filter(value => value.id === event.value)[0].value;
              this.refreshFormConfig(true);
            }, hidden: () => this.useProfiles
          }, {
            field: 'exportProfile',
            'required': true,
            column: 3,
            type: TYPE.DROPDOWN,
            filter: true,
            options: () => this.exportProfiles,
            changed: event => {
              this.selectedProfile = this.exportProfiles.filter(value => value.id === event.value)[0].value;
              this.refreshSelectedProfileTemplateValue();
              this.refreshFormConfig(true);
            }, hidden: () => !this.useProfiles
          }, {
            field: 'customStartDate',
            'required': true,
            column: 2,
            type: TYPE.DATE,
          }, {
            field: 'customEndDate',
            'required': true,
            column: 2,
            type: TYPE.DATE,
          }, {
            field: 'exportFormat',
            'required': true,
            column: 2,
            type: TYPE.DROPDOWN,
            options: () => this.exportFormats
          },
            {
              field: 'zipFile',
              column: 2,
              type: TYPE.CHECKBOX,
            }, {
            column: 1,
            type: TYPE.NONE,
          },
          ]
      }, {
        group: 'filters',
        fields: this.getTemplateFilterFormConfig(clearRecord)
      }
    ];
    this.reloadForm();
  }

  private reloadForm() {
    setTimeout(() => {
      this.validateForm();
      this.ccForm?.reloadFieldValueMap();
      this.refreshTableHeight()
      this.markForCheck();
    })
  }

  private refreshSelectedProfileTemplateValue() {
    if (this.useProfiles && this.selectedProfile) {
      this.selectedTemplate = this.exportTemplates.filter(value => value.id === this.selectedProfile.exportTemplate)[0].value;
      this.formRecord.exportTemplate = this.selectedProfile.exportTemplate;
      this.formRecord.exportFormat = this.selectedProfile.exportFormat;
    }
  }

  private getTemplateFilterFormConfig(clearRecord: boolean): FormFieldConfig[] {
    const filterFormConfigs = [];
    if (clearRecord) {
      const customStartDate = this.formRecord.customStartDate;
      const customEndDate = this.formRecord.customEndDate;
      const exportTemplate = this.formRecord.exportTemplate;
      const exportProfile = this.formRecord.exportProfile;
      const exportFormat = this.formRecord.exportFormat ? this.formRecord.exportFormat : ReportProfile.EXPORT_FORMAT.CSV;
      // for (const key in this.formRecord.filterMap) {
      //   this.formRecord.filterMap[key] = undefined;
      // }
      for (const key in this.formRecord) {
        this.formRecord[key] = undefined;
      }
      this.formRecord.exportTemplate = exportTemplate;
      this.formRecord.exportProfile = exportProfile;
      this.formRecord.customStartDate = customStartDate;
      this.formRecord.customEndDate = customEndDate;
      this.formRecord.exportFormat = exportFormat;
      this.formRecord.zipFile = false;
    }

    if (this.selectedTemplate) {
      for (const key in this.selectedTemplate.parameterMap) {
        const fieldType = this.selectedTemplate.parameterMap[key];
        const fieldConf: FormFieldConfig = {
          field: key,
          label: key,
          'required': false,
          column: 2,
          type: fieldType === 'String' ? TYPE.TEXT :
            (fieldType === 'Double' ? TYPE.DECIMAL :
              (fieldType === 'Integer' ? TYPE.INTEGER :
                (fieldType === 'Boolean' ? TYPE.CHECKBOX : TYPE.TEXT)))
        };
        if (key.toLowerCase() === 'exchange' || key.toLowerCase() === 'exchangecode') {
          fieldConf.type = TYPE.MULTISELECT;
          fieldConf.filter = true;
          fieldConf.options = () => this.exchanges;
          // fieldConf.changed=(event, event2) => {
          //   // event2[key] = event.value.join(',');
          //   console.log("------> event2[key] "+event2[key])
          // }
        }

        filterFormConfigs.push(fieldConf);
        if (this.useProfiles && this.selectedProfile) {
          if (key.toLowerCase() === 'exchange' || key.toLowerCase() === 'exchangecode') {
            if (this.selectedProfile.filterMap[key])
              this.formRecord[key] = this.selectedProfile.filterMap[key].split(',');
          } else {
            this.formRecord[key] = this.selectedProfile.filterMap[key];
          }
        }
        // console.log("---------------> " + JSON.stringify(this.formRecord))

        // this.ccForm.reloadFieldValueMap();
        //   console.log("---------------> " + this.selectedProfile.filterMap[test])
        // if (this.useProfiles && this.selectedProfile && test in this.selectedProfile.filterMap) {
        //   this.formRecord[test] = 'totoZ';// + this.selectedProfile.filterMap[key]+'';
        //   console.log("---------------> " + this.selectedProfile.filterMap[test])
        // }
      }
    }

    return filterFormConfigs;
  }

  protected initData() {
    super.initData();
    this.settingsFormLoadingProgressValue = 0;
    this.profileAbsService.getExportTemplatesForm(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.exportTemplates = this.getFields(fieldResult);
      if (this.storageService.check(this.origin + CookieNames.ARCHIVE_FORM_RECORD)) {
        this.formRecord = JSON.parse(this.storageService.get(this.origin + CookieNames.ARCHIVE_FORM_RECORD));
        // console.log("------>formRecord " + JSON.stringify(this.formRecord));
        const exportTemplate = this.exportTemplates.find(value => value.id === this.formRecord.exportTemplate);
        if (exportTemplate) {
          this.selectedTemplate = exportTemplate.value;
        }
      }
      if (!this.selectedTemplate && this.exportTemplates && this.exportTemplates.length > 0) {
        this.selectedTemplate = this.exportTemplates[0].value;
        this.formRecord.exportTemplate = this.selectedTemplate.name;
      }
      this.refreshSelectedProfileTemplateValue();
      if (!this.formRecord.exportFormat)
        this.formRecord.exportFormat = ReportProfile.EXPORT_FORMAT.CSV;
      // queueMicrotask(() => {
      // this.refreshFormConfig(false);
      // this.oneDataLoadComplete();
      // this.detectChanges();
      // });
    });

    this.profileAbsService.getProfileFieldsForm(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.exportProfiles = this.getFields(fieldResult);
      if (this.storageService.check(this.origin + CookieNames.ARCHIVE_FORM_RECORD)) {
        this.formRecord = JSON.parse(this.storageService.get(this.origin + CookieNames.ARCHIVE_FORM_RECORD));
        // console.log("------>formRecord " + JSON.stringify(this.formRecord));
        const exportProfile = this.exportProfiles.find(value => value.id === this.formRecord.exportProfile);
        if (exportProfile) {
          this.selectedProfile = exportProfile.value;
        }
      }
      if (!this.selectedProfile && this.exportProfiles && this.exportProfiles.length > 0) {
        this.selectedProfile = this.exportProfiles[0].value;
        this.formRecord.exportProfile = this.selectedProfile.name;
      }
      this.refreshSelectedProfileTemplateValue();
      if (!this.formRecord.exportFormat && this.selectedProfile)
        this.formRecord.exportFormat = this.selectedProfile.exportFormat;
      // this.forceDay();
      // this.refreshFormConfig(false);
      this.oneDataLoadComplete();
      // this.detectChanges();
    });
    this.exportFormats = [];
    // tslint:disable-next-line:forin
    for (const key in ReportProfile.EXPORT_FORMAT) {
      this.exportFormats.push(new FieldRecord(key, key.toLowerCase()));
    }
    this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.exchanges = this.getFields(fieldResult);
      this.oneDataLoadComplete();
      // this.detectChanges();
    });
  }

  private oneDataLoadComplete() {
    this.settingsFormLoadingProgressValue += 100 / 2;
    if (this.settingsFormLoadingProgressValue === 100) {
      this.forceDay();
      this.refreshFormConfig(false);
      this.reloadForm();
    }
  }

  executePreview(download: boolean = false) {
    if (this.formRecord) {
      const cleanRecord = this.getCleanRecord(download);
      this.setLoading(true);
      this.profileAbsService.downloadForProfileAsync(this.origin, cleanRecord)
        .subscribe(apiValidation => {
          if (apiValidation.success) {
            this.currentGeneratedProfile = cleanRecord;
            this.startCheckingReportTask(apiValidation.item, download);
          } else {
            this.errorMessage(apiValidation.message);
            this.setLoading(false);
          }
        });
    }
  }

  private setLoading(loading: boolean) {
    // this.tableLoading = loading;
    this.formLoading = loading;
    this.markForCheck();
  }

  private getCleanRecord(download: boolean) {
    const tempFormRecord = {...this.formRecord};
    for (const key in this.selectedTemplate.parameterMap) {
      const fieldType = this.selectedTemplate.parameterMap[key];
      if (!tempFormRecord[key] && fieldType === 'Boolean') {
        tempFormRecord[key] = 'false';
      }
    }
    const filterMap = {};
    for (let key of Object.keys(tempFormRecord)) {
      const fieldType = this.selectedTemplate.parameterMap[key];
      if (key.toLowerCase() === 'exchange' || key.toLowerCase() === 'exchangecode') {
        if (tempFormRecord[key])
          filterMap[key] = tempFormRecord[key].join(',');
      } else if (!['exportTemplate', 'selectedTemplate'].includes(key)) {
        if (['customStartDate', 'customEndDate'].includes(key) && tempFormRecord[key]) {
          const [day, month, year] = tempFormRecord[key].split('/');
          // const date = new Date(+year, +month - 1, +day);
          // filterMap[key] = dateFormat(date, "yyyy-mm-dd");
          filterMap[key] = year + '-' + month + '-' + day;
        } else if ((this.formRecord[key] || fieldType === 'Boolean')) {
          filterMap[key] = tempFormRecord[key];
        }
      }
    }
    tempFormRecord.filterMap = filterMap;
    const reportProfile: ReportProfile = {
      exportTemplate: this.selectedTemplate.name,
      title: this.useProfiles && this.selectedProfile ? this.selectedProfile.title : this.selectedTemplate.name,
      name: (download ? 'd_' : 'p_') + this.selectedTemplate.name,
      exportFormat: tempFormRecord.exportFormat, //download ? tempFormRecord.exportFormat : ReportProfile.EXPORT_FORMAT.CSV,
      zipFile: download ? tempFormRecord.zipFile : false,
      filterMap: tempFormRecord.filterMap,
      exportDateMode: EXPORT_DATE_MODE.CUSTOM,
    };
    return reportProfile;
  }

  startCheckingReportTask(taskId: string, download: boolean): void {
    const intervalMs = this.appConfigService.reportCheckInterval;
    const limit = this.appConfigService.reportCheckCallLimit;

    // IMPORTANT: no takeUntil(this.destroy$) here, on purpose
    timer(0, intervalMs)
      .pipe(
        take(limit),

        // poll status (no overlap)
        exhaustMap(() =>
          this.reportTaskService.check(taskId).pipe(
            catchError(err => {
              // if component is destroyed, avoid UI side-effects
              if (!this.destroyed) {
                this.errorMessage(String(err));
                this.setLoading(false);
              }
              return EMPTY;
            }),
          ),
        ),

        tap(v => {
          if (!v.success && !this.destroyed) {
            this.errorMessage(v.message);
            this.setLoading(false);
          }
        }),
        filter(v => v.success),

        map(v => v.item as ReportTask | null),
        filter((t): t is ReportTask => !!t),

        // stop when terminal
        filter(task => task.state !== ReportTask.STATE.IN_PROGRESS),
        take(1),

        // terminal handling
        switchMap(task => {
          if (task.state === ReportTask.STATE.ERROR) {
            if (this.destroyed) {
              this.notificationService.createNotification(
                Notification.TYPE.PREVIEW,
                Notification.STATE.ERROR,
                task.message,
                this.userInfoStorageService.getUsernameFromStorage(),
                taskId,
              );
            } else {
              this.infoMessage(task.message);
              this.setLoading(false);
            }
            return EMPTY;
          }

          if (task.state !== ReportTask.STATE.TREATED) {
            if (!this.destroyed) {
              this.errorMessage(`Report task ${taskId} ended in unexpected state: ${task.state}`);
              this.setLoading(false);
            }
            return EMPTY;
          }

          // TREATED -> fetch file
          return this.reportTaskService.download(taskId).pipe(
            catchError(err => {
              if (!this.destroyed) {
                this.errorMessage(String(err));
                this.setLoading(false);
              }
              return EMPTY;
            }),
          );
        }),

        tap(fileResp => {
          if (!fileResp.success && !this.destroyed) {
            this.errorMessage(fileResp.message);
            this.setLoading(false);
          }
        }),
        filter(fileResp => fileResp.success),
      )
      .subscribe((apiFileResponse: ApiFileResponse) => {
        // If destroyed, do NOT touch UI; only create notification
        if (this.destroyed) {
          this.notificationService.createNotification(
            this.origin === ReportTask.Origin.WEB_REPORT_FORM ? Notification.TYPE.REPORT : Notification.TYPE.RECAP,
            Notification.STATE.TREATED,
            (this.origin === ReportTask.Origin.WEB_REPORT_FORM ? 'Report ' : 'Recap ') +
            apiFileResponse.fileName +
            ' generated',
            this.userInfoStorageService.getUsernameFromStorage(),
            taskId,
          );
          return;
        }

        // Normal alive behavior (same as before)
        this.currentApiFileResponse = apiFileResponse;

        if (download) {
          FileUtils.download(apiFileResponse);
        } else {
          this.readFile();
        }

        this.markForCheck();
        this.setLoading(false);
      });
  }


  readFile() {
    if (!this.currentApiFileResponse) {
      this.reportFormTabs.splice(0);
      return;
    }
    this.setLoading(true);
    let reader: FileReader = new FileReader();
    const data: Blob = base64StringToBlob(this.currentApiFileResponse.item, this.currentApiFileResponse.contentType);
    reader.onload = (e) => {
      if (this.currentGeneratedProfile.exportFormat == EXPORT_FORMAT.CSV) {
        this.readCSVResult(reader);
      } else if (this.currentGeneratedProfile.exportFormat == EXPORT_FORMAT.XLS)
        this.readXLSResult(e, reader);
      setTimeout(() => {
        this.refreshTableHeight();
        this.setLoading(false);
        this.markForCheck();
      });
    }
    if (this.currentGeneratedProfile.exportFormat == EXPORT_FORMAT.CSV)
      reader.readAsText(data);
    else if (this.currentGeneratedProfile.exportFormat == EXPORT_FORMAT.XLS)
      reader.readAsBinaryString(data);
  }

  private readCSVResult(reader: FileReader) {

    this.reportFormTabs.splice(0);
    this.reportFormTabs.push({tab: '', tableConfig: [], records: [], totalRecords: 0});

    const reportFormTab: ReportFormTab = this.reportFormTabs[0];
    const tableConfigTemp: TableColumnConfig[] = [];
    const recordsTemp: any[] = [];
    let csv: any = reader.result;
    let allTextLines = csv.split(/\r|\n|\r/);

    //Table Headings
    let headers = allTextLines[0].split(',');
    if (allTextLines[0].length > 0) {
      for (let j = 0; j < headers.length; j++) {
        const field: string = headers[j] ? headers[j].replace(new RegExp('"', 'g'), '') : '';
        tableConfigTemp.push({
          field: field,
          label: field,
          width: field.length * 6 + 50,
          notSortable: true,
          notResizable: true,
          notFilterable: true
        });
      }
      allTextLines = allTextLines.filter(value => value && value.trim().length > 0);
      reportFormTab.totalRecords = allTextLines.length > 0 ? allTextLines.length - 1 : 0;
      for (let i = 1; i < allTextLines.length; i++) {
        if (allTextLines[i]) {
          const rowValue: string[] = allTextLines[i].split(',');
          const record: any = {};
          for (let h = 0; h < headers.length; h++) {
            const field: string = headers[h] ? headers[h].replace(new RegExp('"', 'g'), '') : '';
            record[field] = rowValue[h] ? rowValue[h].replace(new RegExp('"', 'g'), '') : '';
          }
          recordsTemp.push(record);
        }
      }
      if (reportFormTab.tableConfig.filter(({field: id1}) => !tableConfigTemp.some(({field: id2}) => id2 === id1)).length == 0) {
        reportFormTab.tableConfig = tableConfigTemp;
      }
      reportFormTab.records = recordsTemp;
    } else {
      reportFormTab.records = [];
      reportFormTab.tableConfig = [];
      reportFormTab.totalRecords = 0;
    }
  }

  private readXLSResult(e: any, reader: FileReader) {
    /* read workbook */
    const bstr: string = e.target.result;
    const wb: XLSX.WorkBook = XLSX.read(bstr, {type: 'binary'});

    /* get tabs */
    this.reportFormTabs.splice(0);
    const reportFormTabsTemp: ReportFormTab[] = [];
    for (let i = 0; i < wb.SheetNames.length; i++) {
      const wsname: string = wb.SheetNames[i];
      if (!wsname.toLowerCase().includes('sheet')) {
        const reportFormTabTemp: ReportFormTab = {tab: wsname, tableConfig: [], records: [], totalRecords: 0};
        reportFormTabsTemp.push(reportFormTabTemp);
      }
    }

    this.reportFormTabs = reportFormTabsTemp;
    for (let tabIndex = 0; tabIndex < this.reportFormTabs.length; tabIndex++) {
      const selectedTab: ReportFormTab = this.reportFormTabs[tabIndex];
      if (selectedTab) {
        selectedTab.records.splice(0);
        const ws: XLSX.WorkSheet = wb.Sheets[selectedTab.tab];
        const rowStart = this.selectedTemplate.startRow ? this.selectedTemplate.startRow : 0;
        let data = <AOA>(XLSX.utils.sheet_to_json(ws, {header: 1, raw: false}));
        if (data.length > 0) {
          const dataHeader = data[rowStart - 2 >= 0 ? rowStart - 2 : rowStart - 1];
          if (dataHeader.length > 0) {
            selectedTab.tableConfig.splice(0);
            dataHeader.forEach(value => {
              selectedTab.tableConfig.push({
                field: value,
                label: value,
                width: value.length * 6 + 50,
                notSortable: true,
                notResizable: true,
                notFilterable: true,
              });
            });

            data = <AOA>(XLSX.utils.sheet_to_json(ws, {header: dataHeader, raw: false}));
            selectedTab.totalRecords = data.length > 0 ? data.length - 1 : 0;
            selectedTab.records.push(...data.slice(1));
          } else {
            selectedTab.records = [];
            selectedTab.tableConfig = [];
            selectedTab.totalRecords = 0;
          }
        }
      }
      this.reportFormTabs = [...this.reportFormTabs];
    }
  }

  validateForm(): boolean {
    if (!this.formRecord) {
      return false;
    }
    let valid: boolean = true;
    this.formConfig.forEach(grpConfig => {
      grpConfig.fields.forEach(config => {
        if ((!config.hidden || !config.hidden(this.formRecord)) && config.required
          && (!this.formRecord[config.field] || (this.formRecord[config.field] + '').length === 0)) {
          valid = false;
        }
      });
    });
    return valid;
  }

  download() {
    this.executePreview(true);
  }

  formRecordChanged(formRecord: any) {
    //store record
    this.storageService.set(this.origin + CookieNames.ARCHIVE_FORM_RECORD, JSON.stringify(this.formRecord));
    // console.log("---------------> " + JSON.stringify(this.formRecord))
  }

  forceDay() {
    if (this.forceDayValue) {
      this.setDateTo();
    }
    //store forcePreviousDay
    this.storageService.set(this.origin + CookieNames.ARCHIVE_FORM_FORCEDAY, JSON.stringify(this.forceDayValue));
  }

  setUseProfiles() {
    this.storageService.set(this.origin + CookieNames.ARCHIVE_FORM_USEPROFILES, JSON.stringify(this.useProfiles));
  }

  protected setDateTo() {
  }

  refreshTableHeight() {
    queueMicrotask(() => {
      if (this.reportFormTabs.length > 1)
        this.tableHeight = 'calc( 100vh - ' + (this.ccForm.el.nativeElement.offsetHeight + 110) + 'px )';
      else
        this.tableHeight = 'calc( 100vh - ' + (this.ccForm.el.nativeElement.offsetHeight + 70) + 'px )';
    });
  }
}
